<template>
    <div>
        <div :class="{'open': openSuggestion }" v-on-clickaway="away" class="btn-group multi-select btn-block">
            <input
                :style="{width : width || 'auto' } "
                @keyup="open=true"
                type="text"
                class="form-control multi-select-control"
                v-model="filter"
                :placeholder="placeholder + ' ' + numberSelected"
            />
            <button class="btn btn-delete" v-if="value.length" v-on:click.prevent="removeAll">
                <i class="fa fa-remove"></i>
            </button>
            <ul class="dropdown-menu" :class="size">
                <li v-for="l, i in value" v-on:click="suggestionClick(l)" >
                    <i class="fa fa-check-square"></i>
                    &nbsp;&nbsp;
                    <span v-html="displaySelected(l)"></span>
                </li>


                <li v-for="l, i in list" v-on:click="suggestionClick(l)" v-show="filtered(l)" >
                    <i v-if="!isSelected(l)" class="fa fa-square-o"></i>
                    <i v-if="isSelected(l)" class="fa fa-check-square"></i>
                    &nbsp;&nbsp;
                    <span v-html="display(l)"></span>
                </li>
            </ul>
            <button v-on:click.prevent="toggleOpen" class="btn btn-trigger"><i class="fa fa-caret-down"></i></button>
        </div>

    </div>
    </div>
</template>



<script type="text/babel">
    import { mixin as clickaway } from 'vue-clickaway';

    export default{
        data(){
            return{

                open: false,
                current: 0,
                filter:'',
                suggestions: [],
                selections: [],
                title: ''
            }
        },
        computed:{
            //The flag
            openSuggestion () {
                return this.open === true;
            },
            numberSelected(){
                return (this.value.length)?  " (" + this.value.length + ")" : "";
            },
            sortedList(){
                var _this = this;
                return this.list.sort(function(a, b) {
                    var x = _this.isSelected(a);
                    var y = _this.isSelected(b);
                    return (x === y)? 0 : x? -1 : 1;
                });
            },


        },
        filters:{

        },
        methods: {
            getLabel(l){
                var val;

                if(typeof l == "string") {  val = l; }
                else if (typeof l == "object" && l[this.label]) {  val = l[this.label]; }
                else if (typeof l == "object" && l.label){ val = l.label }
                else val = null;
                return val;
            },
            getId(l){
                var val;
                if(typeof l == "string") {  val = l; }
                else if (typeof l == "object" && l[this.id]) {  val = l[this.id]; }
                else if (typeof l == "object" && l.id){ val = l.id }
                else val = null;
                return val;
            },
            filtered(l){
                var val = this.getLabel(l);
                if(!val) return false;
                if( val.toLowerCase().startsWith(this.filter.toLowerCase()) &&  !this.isSelected(l) ) return true;
                return false;

            },
            isSelected(l){
                var id = this.getId(l);
                return this.value.indexOf(id) >= 0;
            },
            display: function(l){
                return this.getLabel(l);
            },
            displaySelected(l){
                var _this = this;
                var selected = this.list.filter(u => {
                    var val = _this.getId(u);
                    return val == l;
                });
                if(!selected) return false;

                return _this.getLabel(selected[0]);

            },
            toggleOpen (){
                this.open = !this.open;
            },
            //When the user changes input
            change() {
                if (this.open == false) {
                    this.open = true;
                    this.current = 0;
                }
            },

            //When one of the suggestion is clicked
            suggestionClick(suggestion) {
                console.log(this.value);

                var val = this.getId(suggestion);
                (this.value.indexOf(val)) >=0 ? this.value.splice(this.value.indexOf(val), 1) : this.value.push(val);
                this.$emit('input', this.value);

            },
            removeAll(){
                this.value.splice(0, this.value.length);
                this.$emit('clear');
            },
            away: function() {
                this.open = false;
            },

        },
        mixins: [ clickaway ],
        props: {
            list: {
                type: Array,
                required: false
            },
            value:{
                required: false
            },
            label:{
                type: String,
                required: false
            },
            id:{
                type: String,
                required: false
            },
            placeholder: {
                type: String,
                required: false
            },
            size: {
                type: String,
                required: false
            },
            width: {
                type: Number,
                required: false
            }
        },

    }
</script>

<style scoped>
    body .multi-select .dropdown-menu li {
        font-size: 12px;
        line-height: 16px;
    }

    body .multi-select .dropdown-menu.lg{
        width: 350px;
    }

    span {
        display: inline;
        vertical-align: top;
    }
    .dropdown-menu li i{

    }

    body .multi-select.open .dropdown-menu{
        display: block;
    }
    .btn-group>.btn:first-child{
        border-right: none;
    }
    .btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
        border-radius: 0;
        border-left: 0;
        border-right: 0;
    }
    .multi-select-control{
        border-radius: 4px 0 0 4px;
        border: 1px solid #e2e2e2;
        border-right: 0;
    }

</style>


// WEBPACK FOOTER //
// MultiSelect.vue?28d54213